import { Link } from "react-router-dom";
import { useT } from "../../i18n";

interface FooterLink {
  key: "faq" | "pricing" | "blog" | "legal" | "privacy" | "terms" | "contact";
  href: string;
}

const LINKS: FooterLink[] = [
  { key: "faq", href: "/how-it-works" },
  { key: "pricing", href: "/pricing" },
  { key: "blog", href: "/blog" },
  { key: "legal", href: "/legal" },
  { key: "privacy", href: "/privacy" },
  { key: "terms", href: "/terms" },
  { key: "contact", href: "/contact" },
];

export default function Footer() {
  const t = useT();

  return (
    <footer className="border-t border-line px-4 pb-9 pt-7 sm:px-6">
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-muted">
        <span>LE COIN VTC © {new Date().getFullYear()}</span>

        {LINKS.map((link) => (
          <Link
            key={link.key}
            to={link.href}
            className="text-muted no-underline transition-colors hover:text-ink"
          >
            {t.footer[link.key]}
          </Link>
        ))}

        {/* <span className="text-faint">{t.footer.prototype}</span> */}
      </div>
    </footer>
  );
}
